<template lang="pug">
  #taka-widget(
    v-show="providers.length"
    :style=`{
      '--taka-primary': color,
      '--taka-bottom-offset': bottomOffset,
      '--taka-offset-x': offsetX,
      '--taka-widget-border-color': borderColor,
      '--taka-widget-text-color': textColor,
    }`
    :class="{ 'taka-is-mobile': mobileCheck(), 'taka-is-left': left, 'taka-is-open': widgetIsOpen, 'in-page-flow': inPageFlow }"
  )
    #taka-widget-card-wrapper(@click="openModal")
      svgicon(@click="widgetIsOpen = true; introPage = true;")(icon="takaicon" width="60" height="60" :color="`var(--taka-widget-border-color) var(--taka-primary) ${left ? 'var(--taka-primary)' : 'black'} white black white white`")
      #taka-widget-card(ref="takaWidgetCard")
        .text {{ $t('take_meeting') }}
        .text {{ $t('with_an_expert') }}
    modal(v-if="open")
      #top-bar
        svgicon#top-logo(icon="takaicon" width="110" height="110" :color="`var(--taka-widget-border-color) var(--taka-primary) ${left ? 'var(--taka-primary)' : 'black'} white black white white`")
      #taka-intro-page(v-if="introPage")
        .taka-intro-columns
          .taka-intro-column
            .taka-intro-img-wrapper(v-if="takaIntroDesktopVideoUrl !== ''")
              video(autoplay loop)#taka-intro-img(:src="$screen.width > 700 ? takaIntroDesktopVideoUrl : takaIntroMobileVideoUrl")(:poster="$screen.width > 700 ? takaIntroDesktopImgUrl : takaIntroMobileImgUrl"  @load="setIntroBackground")
                img(:src="$screen.width > 700 ? takaIntroDesktopImgUrl : takaIntroMobileImgUrl" @load="setIntroBackground")
            .taka-intro-img-wrapper(v-else)
              img#taka-intro-img(:src="takaIntroDesktopImgUrlBackground")
              img#taka-intro-img(:src="takaIntroDesktopImgUrl")
          button#taka-button(@click="openFrame()") {{ $t('schedule_meeting') }}
      iframe#taka-iframe(v-if="!introPage" width="100%" height="100%" :src="`${determineDomain}?primaryColor=${color.replace(/#/g, '%23')}&lang=${lang}&destinationName=${encodeURI(settings.company_name)}&countryPrefix=${countryPrefix}`")
      svgicon#close-btn(v-if="introPage" @click="open = false; widgetIsOpen = alwaysOpen;enableScroll()" icon="close" width="32" height="32" color="white grey")

</template>

<script>
import Modal from '@/components/RcModal.vue';
import apiProviderService from '@/services/providers';
import apiSettingsService from '@/services/settings';
import '@/compiled-icons/takaicon';
import '@/compiled-icons/close';

export default {
  name: 'App',
  components: {
    Modal
  },
  props: {
    openTop: {
      type: Boolean,
      default: true,
    },
    color: {
      type: String,
      default: '#CCCCCC',
    },
    domain: {
      type: String,
      required: true,
    },
    lang: {
      type: String,
      default: 'fr',
    },
    serviceId: {
      type: [String, Number],
      required: true,
    },
    bottomOffset: {
      type: String,
      default: '0px',
    },
    offsetX: {
      type: String,
      default: '0px',
    },
    borderColor: {
      type: String,
      default: 'white',
    },
    textColor: {
      type: String,
      default: 'white',
    },
    text: {
      type: String,
      default: '',
    },
    left: {
      type: Boolean,
      default: false,
    },
    delay: {
      type: Number,
      default: null,
    },
    alwaysOpen: {
      type: Boolean,
      default: false,
    },
    inPageFlow: {
      type: Boolean,
      default: false,
    },
    countryPrefix: {
      type: String,
      default: 'FR'
    }
  },
  data() {
    return {
      open: false,
      takaFavicon: 'takaicon.svg',
      defaultImgUrl: 'default-avatar.png',
      takaIntroDesktopVideoUrl: '',
      takaIntroMobileVideoUrl: '',
      takaIntroDesktopImgUrlBackground: 'palmiers.svg',
      takaIntroDesktopImgUrl: 'back_' + (this.lang || 'fr') +'.svg',
      takaIntroMobileImgUrl: 'taka-intro-mobile.png',
      takaLogoSrc: 'TAKA-LOGO-COULEUR.png',
      imgUrl: null,
      introPage: true,
      selectedProviderId: null,
      languages: ['en', 'es', 'it', 'fr', 'de', 'nl'],
      providers: [],
      settings: {},
      textOverflow: null,
      widgetIsOpen: this.alwaysOpen,
    }
  },
  created() {
    this.calculateApiPwd().then(() => {
      this.getProviders();
      this.getSettings();
    });
  },
  mounted () {
    let implementedLanguage = this.languages.find(language => language == this.lang);
    this.$i18n.locale = implementedLanguage ? this.lang : 'en';
    this.setTopOffset();
    this.setTextOverflow();
    window.addEventListener('click', this.closeWidget);
    window.addEventListener('message', (message) => {
      if (message.data === 'close') {
        this.enableScroll();
        this.open = false;
        if (!this.alwaysOpen) {
          this.widgetIsOpen = false;
        }
      }
      else if(message.data === 'return') {
        this.introPage = true;
      }
    });

    this.takaFavicon = this.determineDomainImage + 'widget/' + 'takaicon.svg';
    this.defaultImgUrl = this.determineDomainImage + 'widget/' + 'default-avatar.png';
    this.takaIntroDesktopImgUrlBackground = this.determineDomainImage + 'widget/' + 'palmiers.svg';
    this.takaIntroDesktopImgUrl = this.determineDomainImage + 'widget/' + 'back_' + (implementedLanguage ? this.lang : 'en') +'.svg';
    this.takaIntroMobileImgUrl = this.determineDomainImage + 'widget/' + 'taka-intro-mobile.png';
    this.takaLogoSrc = this.determineDomainImage + 'widget/' + 'TAKA-LOGO-COULEUR.png';
  },
  destroyed() {
    window.removeEventListener('click', this.closeWidget);
  },
  methods: {
    enableScroll() {
      document.body.style.overflow= "auto";
      if(parent.body) {
        parent.body.style.overflow= "auto";
      }
    },
    disableScroll() {
      document.body.style.overflow= "hidden";
      if(parent.body) {
        parent.body.style.overflow= "hidden";
      }
    },
    async calculateApiPwd() {
      //const origin = window.location.origin.startsWith('http://localhost') ? 'https://demo.taka.travel' : window.location.origin;
      const matches = this.domain.match(/https:\/\/(.*)(\.taka\.travel|\.taka\.rc-preprod\.com)/);
      const originKey = matches[1];
      const pwd = await this.sha256(`${originKey}${process.env.VUE_APP_API_SALT}`);
      window.apiPwd = pwd;
    },
    async sha256(message) {
      // encode as UTF-8
      const msgBuffer = new TextEncoder('utf-8').encode(message);
      // hash the message
      const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
      // convert ArrayBuffer to Array
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      // convert bytes to hex string
      const hashHex = hashArray.map(b => ('00' + b.toString(16)).slice(-2)).join('');
      return hashHex;
    },
    closeWidget(e) {
      if (!this.alwaysOpen) {
        const widget = document.getElementById('taka-widget');
        if (!widget.contains(e.target)) {
          this.widgetIsOpen = false;
        }
      }
    },
    setTextOverflow() {
      const openText = document.getElementById('taka-widget-open-text');
      if (openText) {
        const totalWidth = openText.clientWidth;
        this.textOverflow = totalWidth - 390;
      }
    },
    openModal(e) {
      this.introPage = true;
      this.open = true;
      this.disableScroll();
    },
    setIntroBackground() {
      document.getElementById('taka-intro-img').style.background = 'var(--taka-primary)';
    },
    setTopOffset() {
      const topOffset = this.openTop ? `${this.$refs.takaWidgetCard.scrollHeight}px` : '0px';
      document.documentElement.style.setProperty('--taka-widget-height', topOffset);
    },
    mobileCheck() {
      let check = false;
      (function(a){if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a)||/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0,4))) check = true;})(navigator.userAgent||navigator.vendor||window.opera);
      return check;
    },
    async getProviders() {
      this.providers = await apiProviderService.getProvidersByService(this.domain, this.serviceId);
      if (this.delay !== null) {
        if (!document.cookie.split('; ').find(row => row.startsWith('takaWidgetHasOpenedOnDelay'))) {
          setTimeout(() => {
            this.widgetIsOpen = true;
          }, this.delay);
          document.cookie = "takaWidgetHasOpenedOnDelay=true; expires=Fri, 31 Dec 9999 23:59:59 GMT";
        }
      }
      if (this.providers.length) {
        const searchParams = new URLSearchParams(window.location.search)
        const preOpen = searchParams.get('preOpen') === 'true';
        if (preOpen) {
          this.open = true;
          this.widgetIsOpen = true;
          const preOpen = searchParams.set('preOpen', 'false');
        }
      }
      if (this.providers.length > 1) {
        this.goThroughProviders();
      } else if (this.providers.length) {
        this.selectedProviderId = this.providers[0].id;
      }
      this.setTopOffset();
    },
    goThroughProviders() {
      if (this.providers.length) {
        for(let i = this.providers.length - 1; i > 0; i--){
          const j = Math.floor(Math.random() * (i))
          const temp = this.providers[i]
          this.providers[i] = this.providers[j]
          this.providers[j] = temp
        }
        this.selectedProviderId = this.providers[0].id;
      }
      setTimeout(this.goThroughProviders, 3000);
    },
    async getSettings() {
      const settings = await apiSettingsService.getSettings(this.domain);
      this.settings = settings.reduce((acc, it) => {
        acc[it.name] = it.value;
        return acc;
      }, {})
      this.setTopOffset();
    },
    openFrame() {
      this.introPage = false;
    },
  },
  computed: {
    determineDomain() {
      if(window.location.origin.includes('preprod') || window.location.origin.includes('localhost')) {
        return 'https://demo.taka.rc-preprod.com/front/#/services/1/language';
      }
      else {
        return this.domain + '/front/#/services/1/language';
      }
    },
    determineDomainImage() {
      if(window.location.origin.includes('preprod') || window.location.origin.includes('localhost')) {
        return 'https://demo.taka.rc-preprod.com/';
      }
      else {
        return this.domain+'/';
      }
    }
  }
}
</script>

<style lang="scss">

  #taka-widget {

    iframe {
      height: calc(100% - 16px);
      margin-top: 16px;
      border: none;
    }

    &:not(.in-page-flow) {
      line-height: 1.15;
      position: fixed;
      z-index: 1002;
      bottom: var(--taka-bottom-offset);

      &:not(.taka-is-left) {

        @media screen and (max-width: 344px) {
          right: 0;
        }

        right: var(--taka-offset-x);

        #taka-widget-open-text {
          right: 30px;
          padding: 8px 34px 10px 16px;
          box-shadow: -2px 3px 3px #00000026;
        }
      }

      &.taka-is-left {

        @media screen and (max-width: 344px) {
          left: 0;
        }
        left: var(--taka-offset-x);

        #taka-widget-open-text {
          left: 30px;
          padding: 8px 16px 10px 34px;
          box-shadow: 2px 3px 3px #00000026;
        }
      }
    }

    &.in-page-flow {
      display: inline-block;
    }

    @import url('https://fonts.googleapis.com/css2?family=Lato:wght@300;400;700;900&display=swap');
    font-family: 'Lato', sans-serif;

    .primary-text {
      color: var(--taka-primary);
    }

    &.taka-is-mobile {

      #open-taka-modal {
        font-size: 12px;
      }
    }

    #taka-widget-card-open {
      margin: 0 32px -30px auto;
      background: var(--taka-primary);
      position: relative;
      box-shadow: 3px 3px 3px #00000026;
      border-radius: 50%;
      width: 70px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 0;

      #taka-widget-open-text {
        z-index: -1;
        border: 2px solid var(--taka-widget-border-color);
        border-radius: 15px;
        position: absolute;
        display: flex;
        font-size: 16px;
        font-weight: 900;
        box-sizing: border-box;
        max-width: 300px;
        width: calc(100vw - (30px + (var(--taka-offset-x) * 2)));
        color: var(--taka-widget-text-color);
        background: var(--taka-primary);
      }
    }
    &.taka-is-open {

      #taka-widget-card-open {

        #taka-widget-open-text {
          display: none;
        }
      }
    }
    &:not(.taka-is-open) {

      #taka-widget-card-open {
        margin-bottom: var(--taka-widget-height);
        margin-right: 0;
      }

      #taka-widget-card-open + * {
        display: none;
      }
    }

    #taka-widget-card-wrapper {
      cursor: pointer;
      font-weight: bold;
      z-index: 100;
      bottom: 0;
      right: 0;
      overflow: hidden;
      border-radius: 90px;
      background: white;
      height: 60px;
      width: 320px;
      display: flex;
      flex-direction: row-reverse;
      justify-content: space-between;
      box-shadow: 5px 5px 10px 5px rgba(0,0,0,0.1);

      #taka-widget-card {
        display: inline-block;
        padding: 10px 26px;
        padding-bottom: 12px;

        .text {
          font-size: 16px;
          color: black;

          &:nth-child(2) {
            color: var(--taka-primary);
          }
        }
      }
    }

    .modal-container {
      position: relative;
      border-radius: 20px;
      padding: 0;
      max-width: 900px;
      max-height: 650px;
      height: 88vh;
      width: 95vw;

      @media screen and (max-width: 600px) {
        min-height: 100vh;
        width: calc(100vw - 4px);
        border-radius: 0;
        overflow-y: auto;

        .taka-intro-destination-logo {
          margin: 16px 0 0 0!important;

          img {
            height: 80px!important;
          }
        }

        .taka-intro-columns {
          padding: 0!important;

          // .taka-intro-column {

          //   &:last-of-type {
          //     max-width: 80vw;
          //     padding: 0 16px!important;
          //   }
          // }
        }
      }
      @media screen and (max-width: 700px) {
        overflow: visible;

        #top-bar {
          svg {
            width: 70px!important;
          }
        }
      }

      @media screen and (min-width: 700px) and (max-height: 760px){
        #top-bar {
          svg {
            width: 80px!important;
          }
        }
      }
      #top-bar {
        min-height: 108px;
        position: absolute;
        transform: translateX(-50%);
        margin: -55px 0 0 50%;
        z-index: 2;

        @media screen and (max-width: 700px) {
          margin-top: -12px;
        }

      }

      #close-btn {
        position: absolute;
        top: 16px;
        right: 16px;
        font-size: 32px;
        color: #707070;
        cursor: pointer;
        transition: all 0.5s ease;

        &:hover {
          transform: rotate(90deg);
        }
      }

      #taka-intro-page {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 100%;
        animation: fade 0.5s;
        overflow: hidden;

        .taka-intro-destination-logo {
          margin: 32px 0 0px 0;
          img {
            max-height: 150px;
          }
        }

        .taka-intro-columns {
          max-width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          width: 100%;
          height: 100%;
          box-sizing: border-box;

          @media screen and (max-width: 960px) {
            flex-direction: column;
          }

          .text {
            font-size: 16px;
            font-weight: 300;
            color: #2D2D2D;
            text-align: center;
          }

          .button-text {
            font-size: 14px;
            padding: 16px 0;
            width: 300px;
            max-width: 100%;
            box-sizing: border-box;
          }

          #taka-button {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            right: 100px;
            bottom: 70px;
            position: absolute;
            width: 310px;
            height: 35px;
            border-radius: 99px;
            border: none;
            background: var(--taka-primary);
            color: white;
            font-family: 'Lato', sans-serif;
            text-transform: uppercase;
            padding: 10px 5px;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 0.32px;
            cursor: pointer;

            @media screen and (max-width: 700px) {
              position: relative;
              width: 80%;
              right: 0;
              bottom: 120px;
            }

            button {
              display: block;
              margin: auto 0;

              @media screen and (max-width: 700px) {
                margin: auto;
              }
            }

            #close-taka-intro-btn {
              width: 251px;
              padding: 8px 12px;
            }
          }

          .taka-intro-column {
            // flex-grow: 1;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: flex-start;
            width: 100%;
            position: relative;

            @media screen and (max-width: 700px) {
              height: 100%;
            }

            .taka-intro-img-wrapper {
              display: flex;
              width: 100%;
              color: #858585;
              img {
                height: 18px;
              }
            }
            .taka-intro-img-wrapper {
              border-radius: 20px;

              video#taka-intro-img {
                background: none !important;
                height: 65vh;
                width: 100%;
              }

              img#taka-intro-img {
                height: 100%;
                width: 100%;

                @media screen and (min-width: 100px) {
                  &:nth-child(2) {
                    transform: translateX(-100%);
                  }
                }
                // @media screen and (max-width: 700px) {
                //   width: 100%;
                //   height: auto;
                //   background-color: var(--taka-primary);
                //   margin-top: 60px;
                // }
              }
            }
          }
        }
      }
    }
    .container {
      animation: fade .5s;
      transition: all .5s ease;
    }
  }
  .slide-enter-active, .slide-leave-active {
    transition: transform .5s;
  }
  .slide-enter {
    transform: translateX(100%);
  }
  .slide-leave-to {
    transform: translateX(-100%);
  }
  .slide-leave-active {
    padding-right: 40px;
    position: absolute;
  }

  @keyframes fade {
    0%{opacity:0}
    100%{opacity:1}
  }

</style>
